import { useMemo } from 'react';

export const useBlogFilters = (
  notes: any[], search: string, tagFilter: string | null, 
  isAuthenticated: boolean, userId: string | undefined,
  paginationMode: 'pages' | 'loadMore', currentPage: number, loadedCount: number
) => {
  const NOTES_PER_PAGE = 8;

  const filteredNotes = useMemo(() => {
    if (!notes.length) return [];
    let result = [...notes];
    
    if (tagFilter) {
      result = result.filter(n => n.tags.some((t: string) => t.toLowerCase() === tagFilter.toLowerCase()));
    }
    if (search) {
      result = result.filter(n => {
        const textOnly = n.content.replace(/<[^>]*>/g, '').replace(/&nbsp;/g, ' ');
        return n.title.toLowerCase().includes(search.toLowerCase()) ||
               textOnly.toLowerCase().includes(search.toLowerCase()) ||
               n.tags.some((t: string) => t.toLowerCase().includes(search.toLowerCase()));
      });
    }
    
    // Сортировка: избранные сверху
    result.sort((a, b) => {
      const aIsFav = isAuthenticated && a.favoritedBy.some((u: any) => u.id === userId);
      const bIsFav = isAuthenticated && b.favoritedBy.some((u: any) => u.id === userId);
      if (aIsFav && !bIsFav) return -1;
      if (!aIsFav && bIsFav) return 1;
      return 0;
    });
    return result;
  }, [notes, search, tagFilter, isAuthenticated, userId]);

  const totalPages = Math.max(1, Math.ceil(filteredNotes.length / NOTES_PER_PAGE));

  const displayedNotes = useMemo(() => {
    if (paginationMode === 'pages') {
      return filteredNotes.slice((currentPage - 1) * NOTES_PER_PAGE, currentPage * NOTES_PER_PAGE);
    }
    return filteredNotes.slice(0, loadedCount);
  }, [filteredNotes, paginationMode, currentPage, loadedCount]);

  return { filteredNotes, totalPages, displayedNotes };
};